import { render, staticRenderFns } from "./JobStockList.vue?vue&type=template&id=21745560&"
import script from "./JobStockList.vue?vue&type=script&lang=js&"
export * from "./JobStockList.vue?vue&type=script&lang=js&"
import style0 from "./JobStockList.vue?vue&type=style&index=0&id=21745560&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports